import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '@shared/shared.module';

import { ArticleCategoriesComponent } from './categories.component';

@NgModule({
  declarations: [ArticleCategoriesComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FlexLayoutModule,
    SharedModule,
  ],
  exports: [ArticleCategoriesComponent],
})
export class ArticleCategoriesModule {}
